import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Text } from './styles';
import CardSortModal from '../../../company/components/card-sort-modal';
import TreeTestModal from '../../../company/components/tree-test-modal';

const TesterVideoLink = (props) => {
  const {
    tester,
    project,
    testSessionId,
  } = props;

  const [showCardSortModal, setShowCardSortModal] = useState(false);
  const [treeTestModal, setTreeTestModal] = useState(false);

  const handleClick = () => {
    switch (project.testType) {
      case 'tree_test':
        setTreeTestModal(true);
        break;
      case 'survey':
        // PLBUX-5165: Move participants tab to a new page
        window.open(`/projects/${project.id}/participants-response/${testSessionId}`, '_blank');
        break;
      case 'card_sort':
        setShowCardSortModal(true);
        break;
      case 'unmoderated':
        window.open(`/projects/${project.id}/videos/${tester.id}`, '_blank');
        break;
      default:
        // do nothing
        break;
    }
  };

  return (
    <>
      <Text
        onClick={handleClick}
      >
        {tester.user.profile.firstName}
        {' '}
        {tester.user.profile.lastName}
      </Text>
      {showCardSortModal && (
        <CardSortModal
          show={showCardSortModal}
          onClose={() => setShowCardSortModal(false)}
          hideCardName={project?.hideName}
          testSessionId={testSessionId}
        />
      )}

      {treeTestModal && (
        <TreeTestModal
          show={treeTestModal}
          onClose={() => setTreeTestModal(false)}
          testSessionId={testSessionId}
        />
      )}
    </>
  );
};

TesterVideoLink.propTypes = {
  tester: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  testSessionId: PropTypes.string.isRequired,
};

export default TesterVideoLink;
